const firstLetterCap = (word) => `${word[0].toUpperCase()}${word.slice(1)}`;

export {firstLetterCap};
